var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalandar2262(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.2,
    height: 13.2,
    viewBox: "0 0 13.2 13.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262",
    transform: "translate(-213.4 -293.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M8.555,15.105H4.263A1.263,1.263,0,0,1,3,13.842V6.263A1.263,1.263,0,0,1,4.263,5h7.579a1.263,1.263,0,0,1,1.263,1.263V8.789",
    transform: "translate(211 290.263)",
    fill: "none",
    stroke: "#4f2532",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M16.526,16.526m-2.526,0A2.526,2.526,0,1,0,16.526,14,2.526,2.526,0,0,0,14,16.526",
    transform: "translate(206.947 286.947)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M15,3V5.526",
    transform: "translate(206.579 291)",
    fill: "none",
    stroke: "#4f2532",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M7,3V5.526",
    transform: "translate(209.526 291)",
    fill: "none",
    stroke: "#4f2532",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M3,11H13.105",
    transform: "translate(211 288.053)",
    fill: "none",
    stroke: "#4f2532",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M18,16.5v.95l.632.632",
    transform: "translate(205.474 286.028)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalandar2262);
export default __webpack_public_path__ + "static/media/calandar2262.3fe4585f252c98f44e1ee3b793970c5a.svg";
export { ForwardRef as ReactComponent };